import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('currencies', ['currency'])
export class Currency extends BaseModel {
  @Column()
  sign: string | undefined;
  @Column()
  currency: string | undefined;
  @Column()
  isActive: boolean | undefined;
}
